// Filtro best-effort de nicks ofensivos, para feedback inmediato al elegir el nombre.
// La AUTORIDAD es el backend (lib/timba.php::timba_is_offensive); esto es solo UX.
//  - BADWORDS: insultos fuertes → se buscan como subcadena.
//  - BADWORDS_WORD: vulgaridades suaves que son subcadena de palabras legítimas (culo→oráculo,
//    verga→Vergara, pija→pijama, trola→controla) → solo bloquean como palabra completa.
const BADWORDS = [
  'puto', 'puta', 'putito', 'putita', 'putos', 'putas', 'concha', 'conchud', 'pelotud',
  'forro', 'garca', 'cagon', 'mierda', 'carajo', 'pendej', 'sorete', 'maricon', 'travesti',
  'violador', 'pedofil', 'culiad', 'culiao', 'chupame', 'chupala', 'reconcha', 'requeteputa',
  'nazi', 'hitler', 'mongolic', 'mogolic', 'retardad', 'subnormal',
  'fuck', 'shit', 'bitch', 'cunt', 'nigger', 'faggot', 'asshole', 'pussy', 'whore',
];
const BADWORDS_WORD = [
  'culo', 'culos', 'orto', 'ortos', 'verga', 'vergas', 'pija', 'pijas', 'marica', 'maricas',
  'trolo', 'trola', 'choto', 'chotos', 'pene', 'penes', 'teta', 'tetas', 'ojete', 'ojetes',
];

// Minúsculas, sin acentos y leet básico (0→o, 1→i, 3→e, 4→a, 5/$→s, 7→t, @→a). No toca separadores.
function normBase(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD').replace(new RegExp('[\\u0300-\\u036f]', 'g'), '') // saca acentos
    .replace(/0/g, 'o').replace(/1/g, 'i').replace(/3/g, 'e').replace(/4/g, 'a')
    .replace(/[5$]/g, 's').replace(/7/g, 't').replace(/@/g, 'a');
}

export function isOffensive(s: string): boolean {
  const base = normBase(s);
  const collapsed = base.replace(/[^a-z]/g, '');
  if (collapsed && BADWORDS.some((w) => collapsed.includes(w))) return true;
  return base.split(/[^a-z]+/).filter(Boolean).some((t) => BADWORDS_WORD.includes(t));
}
